import React from 'react';

const InstallStatus = ({ isInstalled }) => {
  if (!isInstalled) return null;

  return (
    <div className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl p-4">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div>
        <p className="text-sm font-semibold text-green-800">App is installed</p>
        <p className="text-xs text-green-600">You are already running ConstructionPro as a PWA</p>
      </div>
    </div>
  );
};

export default InstallStatus;
